import {
  GLOBAL_USER_FEATURE_CHANGE,
  GLOBAL_MODULE_ID_CHANGE,
  GLOBAL_MODULE_OBJECT_CHANGE,
  GLOBAL_MODULES_LIST_CHANGE,
  RESET_REDUX_APP_STATE,
  REMOVE_GLOBAL_TOKEN,
} from "../../actions/types";

export const removeGlobalToken = () => dispatch => {
  dispatch({
    type: REMOVE_GLOBAL_TOKEN,
    payload: {
      token: null
    }
  })
}

export const changeUserFeatures = (features) => (dispatch) => {
  dispatch({
    type: GLOBAL_USER_FEATURE_CHANGE,
    payload: {
      features: features,
    },
  });
};

export const changeModuleId = (moduleId) => (dispatch) => {
  dispatch({
    type: GLOBAL_MODULE_ID_CHANGE,
    payload: { moduleId },
  });
};

export const changeModule = (moduleObject) => (dispatch) => {
  dispatch({
    type: GLOBAL_MODULE_OBJECT_CHANGE,
    payload: { moduleObject },
  });
};

export const changeModulesList = (modulesList) => (dispatch) => {
  dispatch({
    type: GLOBAL_MODULES_LIST_CHANGE,
    payload: { modulesList },
  });
};

export const resetAppState = () => dispatch => {
  dispatch({
    type: RESET_REDUX_APP_STATE,
  })
}

export const combinedNavStateChangeUpdate = (moduleId, moduleObject, clb) => dispatch => {
  dispatch({
    type: RESET_REDUX_APP_STATE,
  });

  dispatch({
    type: GLOBAL_MODULE_ID_CHANGE,
    payload: { moduleId },
  });

  dispatch({
    type: GLOBAL_MODULE_OBJECT_CHANGE,
    payload: { moduleObject },
  });

  if(clb){
    clb();
  }
}
